import { Fragment, useEffect, useState } from "react";

import { WelcomePageLabels } from "../../assets/labels/labels";
import CategoryCard from "../../components/CategoryCard/CategoryCard";
import { Category } from "../../core/models/category.model";
import IntroSection from "./IntroSection";
import Spinner from "../../components/spinner/Spinner";
import LinkButton from "../../components/buttons/LinkButton/LinkButton";
import Emitter from "../../core/services/emitter";

interface CategorySectionProps {
  styleClass?: string,
  categories?: Category[],
  isLoading: boolean,
  onSelected: (category: Category) => void
}

const CategorySection = (props: CategorySectionProps) => {
  const [styleClass, setPropValue1] = useState(props.styleClass);
  const [categories, setPropValue2] = useState(props.categories);
  const [isLoading, setIsLoading] = useState(props.isLoading);

  // Use useEffect to update state when props change
  useEffect(() => {
    setPropValue1(props.styleClass);
    setPropValue2(props.categories);
    setIsLoading(props.isLoading);
  }, [props.styleClass, props.categories, props.isLoading]);
  

  const handleCategorySelected = (category: Category) => {
    props.onSelected(category);
  };

  const renderCategoryList = () => {
    return categories?.map((c, index) => {
      return (
        <CategoryCard category={c} onClick={() => handleCategorySelected(c)} key={index}/>
      );
    })
  };

  const renderLoading = () => {
    if (!isLoading) {
      return <Fragment />;
    }

    return <Spinner styleClass={'mt-4'} message="A carregar categorias..."/>;
  };

  const renderPrivacyTerms = () => {
    const showPrivacyTermsFooter = true; //HelperWebView.isAndroidWebview();
    return (
      <>
        <footer className="footer d-flex flex-column pt-3 pb-8 pb-lg-6">
          {/*<div className="d-flex flex-fill" />  */}
          {showPrivacyTermsFooter && (
            <div className="d-inline-flex justify-content-center align-items-center">
              <LinkButton
                onClick={() => Emitter.emit("OPEN_IAGREE_TEXT", null)}
                styleClass="link-container ms-0 ms-md-2"
                textClass="small"
                valueText="Política de Privacidade"
              />
              <span className="mx-2 small">|</span>
              <LinkButton
                onClick={() => window.open('https://www.keymaster.pt/termos-e-condicoes/', '_self')}
                styleClass="link-container ms-0 ms-md-2"
                textClass="small"
                valueText="Termos & Condições"
              />
            </div>
          )}
        </footer>
      </>
    )
  }

  return (
    <Fragment>
      <IntroSection />
      <div className={`category-container ${styleClass || ""}`} id="category-container">
        <div className="list-instruction-container position-relative pb-3">
          <div className="instruction-text">{WelcomePageLabels.instruction}</div>
        </div>
        <div className="list-scroll-container" id="category-list-scroll-container">
          {renderLoading()}
          <div className="list-container grid-container mt-2 pt-2 pb-0">{renderCategoryList()}</div>
          {renderPrivacyTerms()}
        </div>
      </div>
    </Fragment>
  );
}

export default CategorySection;